(() => {
  if (window.witypowerWallOrdered) { window.witypowerWallOrdered(document); return; }
  function bind(scope) {
    const roots = [...scope.querySelectorAll('[data-wp-wall-ordered]')];
    if (scope.matches?.('[data-wp-wall-ordered]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.wpWallBound) return;
      const dialog = root.querySelector('.wp-wall-dialog');
      const canvas = dialog?.querySelector('.wp-wall-canvas');
      const close = dialog?.querySelector('[data-wp-wall-close]');
      if (!dialog || !canvas || !close) return;
      root.dataset.wpWallBound = 'true';
      let opener;
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-wp-wall-open]');
        if (!link || !root.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !dialog.showModal) return;
        const original = link.querySelector('.wp-wall-art');
        if (!original) return;
        event.preventDefault();
        opener = link;
        const art = original.cloneNode(true);
        art.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        art.querySelectorAll('img').forEach(img => { img.loading='eager'; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src=link.href; });
        canvas.replaceChildren(art);
        dialog.showModal();
        dialog.querySelector('.wp-wall-scroll').scrollTo(0,0);
        close.focus({preventScroll:true});
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if(event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { canvas.replaceChildren(); opener?.focus({preventScroll:true}); });
    });
  }
  window.witypowerWallOrdered = bind;
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>bind(document),{once:true});
  else bind(document);
  document.addEventListener('shopify:section:load',event=>bind(event.target));
})();
